















import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import OptionListBoxSelector from "../../system/selectors/OptionListBoxSelector.vue";
import { DepartmentGroupSelectableMixin } from "./mixins/";
import { FixedLoading } from "../../system";

@Component({
  components: {
    OptionListBoxSelector,
    FixedLoading,
  },
})
export default class DepartmentGroupListSelector extends Mixins(DepartmentGroupSelectableMixin) {
  @Prop({ default: false })
  isClearable: boolean;

  scrollIntoView(): void {
    (this.$refs.selector as OptionListBoxSelector).scrollIntoView();
  }

  @Watch("values")
  async onValuesChanged(newValue: any, oldValue: any): Promise<void> {
    await this.$nextTick();
    this.scrollIntoView();
  }

  @Emit()
  dblclick(e: PointerEvent): void {}
}
